/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CollectionModelConfigFeatureToggleResponse } from '../models/collection-model-config-feature-toggle-response';
import { ConfigFeatureToggleResponse } from '../models/config-feature-toggle-response';
import { ConfigResponse } from '../models/config-response';
import { createConfig } from '../fn/config/create-config';
import { CreateConfig$Params } from '../fn/config/create-config';
import { deleteConfig } from '../fn/config/delete-config';
import { DeleteConfig$Params } from '../fn/config/delete-config';
import { downloadData } from '../fn/config/download-data';
import { DownloadData$Params } from '../fn/config/download-data';
import { getConfig } from '../fn/config/get-config';
import { GetConfig$Params } from '../fn/config/get-config';
import { getConfigFeatureToggle } from '../fn/config/get-config-feature-toggle';
import { GetConfigFeatureToggle$Params } from '../fn/config/get-config-feature-toggle';
import { getConfigFeatureToggles } from '../fn/config/get-config-feature-toggles';
import { GetConfigFeatureToggles$Params } from '../fn/config/get-config-feature-toggles';
import { getConfigs } from '../fn/config/get-configs';
import { GetConfigs$Params } from '../fn/config/get-configs';
import { getConfigs1 } from '../fn/config/get-configs-1';
import { GetConfigs1$Params } from '../fn/config/get-configs-1';
import { PagedModelConfigResponse } from '../models/paged-model-config-response';
import { ProcessResponse } from '../models/process-response';
import { resetConfigFeatureToggle } from '../fn/config/reset-config-feature-toggle';
import { ResetConfigFeatureToggle$Params } from '../fn/config/reset-config-feature-toggle';
import { triggerConfig } from '../fn/config/trigger-config';
import { TriggerConfig$Params } from '../fn/config/trigger-config';
import { updateConfig } from '../fn/config/update-config';
import { UpdateConfig$Params } from '../fn/config/update-config';
import { updateConfigFeatureToggle } from '../fn/config/update-config-feature-toggle';
import { UpdateConfigFeatureToggle$Params } from '../fn/config/update-config-feature-toggle';


/**
 * PRS configuration management. Each config represents a merchant/site synchronization setup. Required role: EASYLOT_ADMIN or PRICE_SYNC_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConfig()` */
  static readonly GetConfigPath = '/config/{configId}';

  /**
   * Get config by ID.
   *
   * Returns the full configuration for a given merchant/site sync setup.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig$Response(params: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
    const obs = getConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get config by ID.
   *
   * Returns the full configuration for a given merchant/site sync setup.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig(params: GetConfig$Params, context?: HttpContext): Observable<ConfigResponse> {
    const resp = this.getConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigResponse>): ConfigResponse => r.body)
    );
  }

  /** Path part for operation `updateConfig()` */
  static readonly UpdateConfigPath = '/config/{configId}';

  /**
   * Replace config.
   *
   * Fully replaces the configuration for the given ID. All fields must be provided.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfig$Response(params: UpdateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace config.
   *
   * Fully replaces the configuration for the given ID. All fields must be provided.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfig(params: UpdateConfig$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteConfig()` */
  static readonly DeleteConfigPath = '/config/{configId}';

  /**
   * Delete config.
   *
   * Permanently deletes a config. Associated processes and data may also be affected.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfig$Response(params: DeleteConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete config.
   *
   * Permanently deletes a config. Associated processes and data may also be affected.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfig(params: DeleteConfig$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getConfigFeatureToggle()` */
  static readonly GetConfigFeatureTogglePath = '/config/{configId}/feature-toggle/{feature}';

  /**
   * Get a single feature toggle.
   *
   * Returns the current state of a specific feature toggle for a config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigFeatureToggle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigFeatureToggle$Response(params: GetConfigFeatureToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigFeatureToggleResponse>> {
    const obs = getConfigFeatureToggle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single feature toggle.
   *
   * Returns the current state of a specific feature toggle for a config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigFeatureToggle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigFeatureToggle(params: GetConfigFeatureToggle$Params, context?: HttpContext): Observable<ConfigFeatureToggleResponse> {
    const resp = this.getConfigFeatureToggle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigFeatureToggleResponse>): ConfigFeatureToggleResponse => r.body)
    );
  }

  /** Path part for operation `updateConfigFeatureToggle()` */
  static readonly UpdateConfigFeatureTogglePath = '/config/{configId}/feature-toggle/{feature}';

  /**
   * Set a feature toggle.
   *
   * Enables or disables a specific feature toggle for a config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfigFeatureToggle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfigFeatureToggle$Response(params: UpdateConfigFeatureToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigFeatureToggleResponse>> {
    const obs = updateConfigFeatureToggle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set a feature toggle.
   *
   * Enables or disables a specific feature toggle for a config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfigFeatureToggle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfigFeatureToggle(params: UpdateConfigFeatureToggle$Params, context?: HttpContext): Observable<ConfigFeatureToggleResponse> {
    const resp = this.updateConfigFeatureToggle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigFeatureToggleResponse>): ConfigFeatureToggleResponse => r.body)
    );
  }

  /** Path part for operation `resetConfigFeatureToggle()` */
  static readonly ResetConfigFeatureTogglePath = '/config/{configId}/feature-toggle/{feature}';

  /**
   * Reset a feature toggle to its default.
   *
   * Resets a feature toggle to the default value defined in the config schema.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetConfigFeatureToggle()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetConfigFeatureToggle$Response(params: ResetConfigFeatureToggle$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigFeatureToggleResponse>> {
    const obs = resetConfigFeatureToggle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reset a feature toggle to its default.
   *
   * Resets a feature toggle to the default value defined in the config schema.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetConfigFeatureToggle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetConfigFeatureToggle(params: ResetConfigFeatureToggle$Params, context?: HttpContext): Observable<ConfigFeatureToggleResponse> {
    const resp = this.resetConfigFeatureToggle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigFeatureToggleResponse>): ConfigFeatureToggleResponse => r.body)
    );
  }

  /** Path part for operation `getConfigs()` */
  static readonly GetConfigsPath = '/configs';

  /**
   * List configs (paginated).
   *
   * Returns a paginated and filterable list of configs.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigs$Response(params: GetConfigs$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelConfigResponse>> {
    const obs = getConfigs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List configs (paginated).
   *
   * Returns a paginated and filterable list of configs.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigs(params: GetConfigs$Params, context?: HttpContext): Observable<PagedModelConfigResponse> {
    const resp = this.getConfigs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelConfigResponse>): PagedModelConfigResponse => r.body)
    );
  }

  /** Path part for operation `createConfig()` */
  static readonly CreateConfigPath = '/configs';

  /**
   * Create a new config.
   *
   * Creates a new merchant/site sync configuration. The config defines how PRS synchronizes data for a specific merchant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfig$Response(params: CreateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
    const obs = createConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new config.
   *
   * Creates a new merchant/site sync configuration. The config defines how PRS synchronizes data for a specific merchant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfig(params: CreateConfig$Params, context?: HttpContext): Observable<ConfigResponse> {
    const resp = this.createConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigResponse>): ConfigResponse => r.body)
    );
  }

  /** Path part for operation `triggerConfig()` */
  static readonly TriggerConfigPath = '/config/{configId}/trigger';

  /**
   * Trigger a sync process for a config.
   *
   * Manually triggers a synchronization process for the given config. Returns the created process resource.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerConfig$Response(params: TriggerConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessResponse>> {
    const obs = triggerConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Trigger a sync process for a config.
   *
   * Manually triggers a synchronization process for the given config. Returns the created process resource.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  triggerConfig(params: TriggerConfig$Params, context?: HttpContext): Observable<ProcessResponse> {
    const resp = this.triggerConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessResponse>): ProcessResponse => r.body)
    );
  }

  /** Path part for operation `getConfigs1()` */
  static readonly GetConfigs1Path = '/configs/all';

  /**
   * Get all configs (unpaginated).
   *
   * Returns all configs as a list. Use `/configs` for the paginated variant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigs1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigs1$Response(params?: GetConfigs1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConfigResponse>>> {
    const obs = getConfigs1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all configs (unpaginated).
   *
   * Returns all configs as a list. Use `/configs` for the paginated variant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigs1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigs1(params?: GetConfigs1$Params, context?: HttpContext): Observable<Array<ConfigResponse>> {
    const resp = this.getConfigs1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConfigResponse>>): Array<ConfigResponse> => r.body)
    );
  }

  /** Path part for operation `getConfigFeatureToggles()` */
  static readonly GetConfigFeatureTogglesPath = '/config/{configId}/feature-toggles';

  /**
   * List feature toggles for a config.
   *
   * Returns all feature toggle states for the given config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigFeatureToggles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigFeatureToggles$Response(params: GetConfigFeatureToggles$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelConfigFeatureToggleResponse>> {
    const obs = getConfigFeatureToggles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List feature toggles for a config.
   *
   * Returns all feature toggle states for the given config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigFeatureToggles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigFeatureToggles(params: GetConfigFeatureToggles$Params, context?: HttpContext): Observable<CollectionModelConfigFeatureToggleResponse> {
    const resp = this.getConfigFeatureToggles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionModelConfigFeatureToggleResponse>): CollectionModelConfigFeatureToggleResponse => r.body)
    );
  }

  /** Path part for operation `downloadData()` */
  static readonly DownloadDataPath = '/config/{configId}/download';

  /**
   * Download config data.
   *
   * Downloads the raw data snapshot associated with a config as a binary file. The file extension depends on the configured data format.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadData()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadData$Response(params: DownloadData$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = downloadData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download config data.
   *
   * Downloads the raw data snapshot associated with a config as a binary file. The file extension depends on the configured data format.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadData(params: DownloadData$Params, context?: HttpContext): Observable<string> {
    const resp = this.downloadData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
